// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';
import DetailedDatesDisclaimer from './DetailedDatesDisclaimer';

// Utils
import { formatMessageWithLocale } from '@/utils/i18n';
import { getDetailedPerformanceAsAtDates, getPerformanceAsAtDates } from '@/utils/disclaimers/comparison';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  detailed?: boolean;
  locale?: Locale;
  showItemNames?: boolean;
}

const PerformanceDisclaimer = ({ items, detailed, locale, showItemNames }: Props) => {
  if (detailed) {
    return (
      <DetailedDatesDisclaimer
        showItemNames={showItemNames}
        globalPrefix={formatMessageWithLocale('Disclaimers.Performance', locale)}
        itemPrefix={formatMessageWithLocale('Disclaimers.EndingOn', locale)}
        itemDates={getDetailedPerformanceAsAtDates(items, locale)}
        locale={locale}
      />
    );
  }
  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.Performance', locale)}
      itemDates={getPerformanceAsAtDates(items, locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.EndingOn', locale)}
      locale={locale}
      showItemNames={showItemNames}
    />
  );
};

export default PerformanceDisclaimer;
